module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ibox-content"
  }, [_c('div', [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": function($event) {
        return _vm.handleSelectedListsChange()
      }
    },
    model: {
      value: (_vm.selectedLists),
      callback: function($$v) {
        _vm.selectedLists = $$v
      },
      expression: "selectedLists"
    }
  }, _vm._l((_vm.contactLists), function(list) {
    return _c('el-checkbox', {
      key: list.id,
      attrs: {
        "label": list.id
      }
    }, [_vm._v("\n            " + _vm._s(list.name) + "\n          ")])
  }), 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a367046","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/email/ContactListsSelect.vue
// module id = 3192
// module chunks = 3